module.exports = __webpack_public_path__ + "img/QHC_logo.531eef79.png";